import styles from './Form.module.scss';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import CustomDropdown from '../../ui/CustomDropdown/CustomDropdown';
// import FleetCustomPhoneInputField from './FleetCustomPhoneInputField/FleetCustomPhoneInputField';
import FleetCustomPhoneInputField from '../../ContactUs/Form/CustomPhoneInputField/CustomPhoneInputField';
import cn from 'classnames';
import rightArrow from '../../../../../src/assets/icons/right-arrow.svg';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

const buildOptions = (fields) => {
  return fields.map((item) => {
    return {
      label: item.fields.label.value,
      value: item.fields.value.value,
    };
  });
};

export default function FleetBusinessFrom({ fields, isSubmitting = false }) {
  const {
    register,
    control,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    trigger,
  } = useFormContext();

  const titleOption = buildOptions(fields.titleOption);
  const IamOption = buildOptions(fields.IamOption);
  const fleetSizeOption = buildOptions(fields.fleetSizeOption);

  const handleSelect = async (option, field) => {
    setValue(field, option.value);
    await trigger(field);
  };
  return (
    <>
      <div className={styles.fields}>
        <div className={cn(styles.field)}>
          <label className={styles.field_label}>{fields.IamTitle.value}</label>
          <div className={styles.field_dropdown}>
            <CustomDropdown
              options={IamOption}
              placeholderValue={
                <span className={styles.field_dropdown_placeholder}>
                  {fields.IamPlaceholder.value}
                </span>
              }
              isOptionsAbsolutePosition
              onSelect={(option) => handleSelect(option, 'role')}
            />
          </div>
          {errors.role && (
            <span className={styles.field_error} style={{ bottom: -15 }}>
              {String(errors.role.message)}
            </span>
          )}
        </div>
        <div className={cn(styles.field)}>
          <label className={styles.field_label}>{fields.titlesTitle.value}</label>
          <div className={styles.field_dropdown}>
            <CustomDropdown
              options={titleOption}
              placeholderValue={
                <span className={styles.field_dropdown_placeholder}>
                  {fields.titlePlaceholder.value}
                </span>
              }
              isOptionsAbsolutePosition
              onSelect={(option) => handleSelect(option, 'title')}
            />
          </div>
          {errors.title && (
            <span className={styles.field_error} style={{ bottom: -15 }}>
              {String(errors.title.message)}
            </span>
          )}
        </div>
      </div>

      <div className={styles.fields}>
        <div className={styles.field}>
          <label className={styles.field_label}>{fields.firstNameTitle.value}</label>
          <input
            className={styles.field_input}
            type="text"
            placeholder={fields.firstNamePlaceholder.value}
            {...register('firstName')}
          />
          {errors.firstName && (
            <span className={styles.field_error}>{String(errors.firstName.message)}</span>
          )}
        </div>
        <div className={styles.field}>
          <label className={styles.field_label}>{fields.lastNameTitle.value}</label>
          <input
            className={styles.field_input}
            type="text"
            placeholder={fields.lastNamePlaceholder.value}
            {...register('lastName')}
          />
          {errors.lastName && (
            <span className={styles.field_error}>{String(errors.lastName.message)}</span>
          )}
        </div>
      </div>
      <div className={styles.fields}>
        <div className={styles.field}>
          <label className={styles.field_label}>{fields.companyTitle.value}</label>
          {/* <FleetCustomPhoneInputField */}
          {/*   placeholder={fields.companyPlaceholder.value} */}
          {/*   control={control} */}
          {/*   name="company" */}
          {/*   trigger={trigger} */}
          {/* /> */}
          <input
            className={styles.field_input}
            type="text"
            placeholder={fields.companyPlaceholder.value}
            {...register('company')}
          />
          {errors.company && (
            <span className={styles.field_error}>{String(errors.company.message)}</span>
          )}
        </div>

        <div className={cn(styles.field)}>
          <label className={styles.field_label}>{fields.fleetSizeTitle.value}</label>
          <div className={styles.field_dropdown}>
            <CustomDropdown
              options={fleetSizeOption}
              placeholderValue={
                <span className={styles.field_dropdown_placeholder}>
                  {fields.fleetSizePlaceholder.value}
                </span>
              }
              isOptionsAbsolutePosition
              onSelect={(option) => handleSelect(option, 'fleetSize')}
            />
          </div>
          {errors.fleetSize && (
            <span className={styles.field_error} style={{ bottom: -15 }}>
              {String(errors.fleetSize.message)}
            </span>
          )}
        </div>
      </div>
      <div className={styles.fields}>
        <div className={styles.field}>
          <label className={styles.field_label}>{fields.phoneNumberTitle.value}</label>
          <FleetCustomPhoneInputField
            placeholder={fields.phonePlaceholder.value}
            control={control}
            name="phoneNumber"
            trigger={trigger}
          />
          {errors.phoneNumber && (
            <span className={styles.field_error}>{String(errors.phoneNumber.message)}</span>
          )}
        </div>
        <div className={styles.field}>
          <label className={styles.field_label}>{fields.emailTitle.value}</label>
          <input
            className={styles.field_input}
            type="text"
            placeholder={fields.emailPlaceholder.value}
            {...register('email')}
            onChange={(e) => {
              const jsonData = {
                id: 'c611a07e-2445-4fa1-b83f-3dac6b74ef83',
                revisionNumber: '1',
                formUrl: 'http://localhost:8000/en/maintenance',
                effectiveFromDate: '2024-04-23 17:08:58',
              };
              setValue('termsAndConditions', JSON.stringify(jsonData));
            }}
          />
          {errors.email && (
            <span className={styles.field_error}>{String(errors.email.message)}</span>
          )}
        </div>
      </div>
      <div className={styles.field}>
        <label className={styles.field_label}>{fields.businessPostcodeTitle.value}</label>
        <input
          className={styles.field_input}
          type="text"
          placeholder={fields.postcodePlaceholder.value}
          {...register('businessPostcode')}
        />
        {errors.businessPostcode && (
          <span className={styles.field_error}>{String(errors.businessPostcode.message)}</span>
        )}
      </div>
      <div className={styles.field}>
        <label className={styles.field_label}>{fields.enquiryTitle.value}</label>
        <textarea
          placeholder={fields.enquirtPlaceholder.value}
          className={styles.field_textarea}
          {...register('enquiry')}
        />
        {errors.enquiry && (
          <span className={styles.field_error}>{String(errors.enquiry.message)}</span>
        )}
      </div>
      <div className={styles.checkboxContainer}>
        <label className={styles.checkboxLabel}>
          <input
            type="checkbox"
            {...register('termsAndConditionsCheck')}
            className={styles.checkboxInput}
            onChange={(e) => {
              const jsonData = {
                revisionNumber: fields.termsAndCondition[0].fields.revisionNumber.value,
                effectiveFromDate: new Date().toISOString().slice(0, 19).replace('T', ' '),
                termsAndConditionsCheck: e.target.checked,
                id: fields.termsAndCondition[0].id,
                formUrl: window.location.href,
              };
              setValue('termsAndConditions', jsonData);
              if (e.target.checked) {
                clearErrors('termsAndConditionsCheck');
              }
            }}
          />
          <span className={styles.customCheckbox}></span>
          <div className={styles.checkboxTextContainer}>
            {!errors.termsAndConditionsCheck && <RichText field={fields?.policyRichText} />}
            {errors.termsAndConditionsCheck && <RichText field={fields?.agreeMsgRichText} />}
            {/* {!errors.termsAndConditionsCheck && <span>{fields.acceptPreTitle.value}</span>} */}
            {/* {errors.termsAndConditionsCheck && ( */}
            {/*   <span style={{ color: 'rgba(227, 99, 108, 1)' }}>{fields.agreeMsg.value}</span> */}
            {/* )} */}
            {/* <a */}
            {/*   href={fields?.acceptSurUrl?.value?.href || '/privacy-policy'} */}
            {/*   style={errors.termsAndConditionsCheck ? { color: 'rgba(227, 99, 108, 1)' } : {}} */}
            {/*   target="_blank" */}
            {/*   rel="noopener noreferrer" */}
            {/* > */}
            {/*   {fields.acceptSurTitle.value} */}
            {/* </a> */}
          </div>
        </label>
      </div>
      <button
        type="submit"
        className={cn(styles.submitButton, { [styles.disabled]: isSubmitting })}
        disabled={isSubmitting}
      >
        {fields.submitTitle.value}
        <img src={rightArrow} alt="arrow" />
      </button>
    </>
  );
}
